<nz-card>
  <div class="collaboration-list-container">
    <div nz-row [nzGutter]="16" nzJustify="end" nzAlign="middle">
      <div nz-col [nzSpan]="24" class="collaboration-header">
        <nz-input-group nzSearch [nzSuffix]="suffixIconSearch" class="search-input">
          <input type="text" nz-input placeholder="Search" [(ngModel)]="searchValue" (input)="onSearch()" />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span nz-icon nzType="search"></span>
        </ng-template>

        <button
          nz-button
          nzType="primary"
          class="create-button"
          (click)="onCreateCollaboration()"
          *ngIf="canViewCreateCollaboration"
        >
          <span nz-icon nzType="plus"></span>
          Create Collaboration
        </button>
      </div>
    </div>

    <div class="collaboration-list-table">
      <nz-table
        #collaborationTable
        [nzData]="filteredData"
        [nzLoading]="isLoading"
        nzTableLayout="fixed"
        nzShowSizeChanger
        nzShowPagination
        [nzPageSizeOptions]="[10, 25, 50]"
        [nzNoResult]="emptyTemplate"
        [nzTotal]="totalCount!"
        [nzVirtualItemSize]="11"
        [nzScroll]="{ x: '80rem', y: 'calc(100vh - 25rem)' }"
      >
        <thead>
          <tr>
            <th
              *ngFor="let header of headers; trackBy: trackByHeader"
              [nzWidth]="header.width"
              [nzSortFn]="header.sortFn"
              [nzSortDirections]="header.sortDirections"
              [nzSortOrder]="header.sortOrder"
              [nzRight]="header.right"
              [nzFilters]="header.listOfFilter"
              [nzFilterFn]="header.filterFn"
              [nzFilterMultiple]="header.filterMultiple"
              appResizableColumn
            >
              {{ header.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of collaborationTable.data; trackBy: trackByCollaboration">
            <td nzEllipsis [nz-tooltip]="getCollaborationEntity(data)">
              {{ getCollaborationEntity(data) }}
            </td>
            <td nzEllipsis [nz-tooltip]="data.name">{{ data.name }}</td>
            <td nzEllipsis [nz-tooltip]="data.description">{{ data.description }}</td>
            <td nzEllipsis [nz-tooltip]="data.objective">{{ data.objective }}</td>
            <td class="text-center">
              <nz-tag [nzColor]="getStatusColor(data.status)">
                {{ getDisplayStatus(data.status) }}
              </nz-tag>
            </td>
            <td>
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                (click)="onViewDatasets(data)"
                [disabled]="!canViewDataset(data)"
              >
                View Datasets
              </button>
            </td>
            <td>{{ data.lastModifiedAt | dateTime }}</td>
            <td>{{ data.createdBy }}</td>
            <td nzRight>
              <button nz-button nz-dropdown [nzDropdownMenu]="collaborationActionMenu">
                <span nz-icon nzType="more"></span>
              </button>
              <nz-dropdown-menu #collaborationActionMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li
                    nz-menu-item
                    *ngIf="canEditOrDelete(data)"
                    (click)="onCollaborationAction(CollaborationAction.EDIT, data)"
                  >
                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                    Edit
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canEditOrDelete(data)"
                    (click)="onCollaborationAction(CollaborationAction.DELETE, data)"
                  >
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                    Delete
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canAddRemoveDatasets(data)"
                    (click)="onCollaborationAction(CollaborationAction.MANAGE_DATASETS, data)"
                  >
                    <span nz-icon nzType="plus" nzTheme="outline"></span>
                    Add/Remove Datasets
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canPause(data)"
                    (click)="onCollaborationAction(CollaborationAction.PAUSE, data)"
                  >
                    <span nz-icon nzType="pause" nzTheme="outline"></span>
                    Pause
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canClose(data)"
                    (click)="onCollaborationAction(CollaborationAction.CLOSE, data)"
                  >
                    <span nz-icon nzType="close" nzTheme="outline"></span>
                    Close
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canResume(data)"
                    (click)="onCollaborationAction(CollaborationAction.RESUME, data)"
                  >
                    <span nz-icon nzType="play-circle" nzTheme="outline"></span>
                    Resume
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canResend(data)"
                    (click)="onCollaborationAction(CollaborationAction.RESEND, data)"
                  >
                    <span nz-icon nzType="play-circle" nzTheme="outline"></span>
                    Resend Invite
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canAcceptOrDecline(data)"
                    (click)="onCollaborationAction(CollaborationAction.ACCEPT, data)"
                  >
                    <span nz-icon nzType="check" nzTheme="outline"></span>
                    Accept
                  </li>
                  <li
                    nz-menu-item
                    *ngIf="canAcceptOrDecline(data)"
                    (click)="onCollaborationAction(CollaborationAction.DECLINE, data)"
                  >
                    <span nz-icon nzType="close-circle" nzTheme="outline"></span>
                    Decline
                  </li>
                  <li nz-menu-item nzDisabled *ngIf="hasNoActions(data)">
                    <span nz-icon nzType="stop" nzTheme="outline"></span>
                    No Actions
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <ng-template #totalTemplate let-total> Total {{ total }} items </ng-template>
    <ng-template #emptyTemplate>
      <nz-empty [nzNotFoundImage]="'simple'" [nzNotFoundContent]="emptyContent"> </nz-empty>
      <ng-template #emptyContent>
        <span *ngIf="searchValue; else noCollaboration"> No collaboration found matching "{{ searchValue }}" </span>
        <ng-template #noCollaboration> No data available. </ng-template>
      </ng-template>
    </ng-template>
  </div>
</nz-card>

<ng-template #confirmDeclineModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <label class="nfl-form-label"> Are you sure you want to decline participation to this collaboration? </label>
    </nz-form-item>
    <div class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="declineModalRef.triggerCancel()">Cancel</button>
        <button *nzSpaceItem nz-button nzType="primary" (click)="declineModalRef.triggerOk()">Decline</button>
      </nz-space>
    </div>
  </form>
</ng-template>

<ng-template #confirmDeleteModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <label class="nfl-form-label">
        Are you sure you want to delete this collaboration? This action cannot be undone.
      </label>
    </nz-form-item>
    <div class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="deleteModalRef.triggerCancel()">Cancel</button>
        <button *nzSpaceItem nz-button nzType="primary" nzDanger (click)="deleteModalRef.triggerOk()">Delete</button>
      </nz-space>
    </div>
  </form>
</ng-template>

<ng-template #confirmPauseActionModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <label class="nfl-form-label"> Are you sure you want to pause this collaboration? </label>
    </nz-form-item>
    <div class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="pauseModalRef.triggerCancel()">Cancel</button>
        <button *nzSpaceItem nz-button nzType="primary" (click)="pauseModalRef.triggerOk()">Pause</button>
      </nz-space>
    </div>
  </form>
</ng-template>

<ng-template #confirmCloseActionModal let-modal>
  <form nz-form nzLayout="vertical">
    <nz-form-item>
      <label class="nfl-form-label"> Are you sure you want to close this collaboration? </label>
    </nz-form-item>
    <div class="button-section">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button (click)="closeModalRef.triggerCancel()">Cancel</button>
        <button *nzSpaceItem nz-button nzType="primary" (click)="closeModalRef.triggerOk()">Confirm Close</button>
      </nz-space>
    </div>
  </form>
</ng-template>

<!-- View Datasets Modal -->
<app-collaboration-view-dataset-modal
  [(visible)]="isViewDatasetsModalVisible"
  [collaboration]="selectedCollaboration"
  (visibleChange)="!$event && (selectedCollaboration = null)"
></app-collaboration-view-dataset-modal>
